import './assets/css/styles.css';

/**
 * Entry point for the public pages: every page that must work without a login.
 *
 * Today that is login, logout and the email unsubscribe page. It does NOT register a service
 * worker and uses a minimal provider stack, so it stays small and never loads the main app.
 *
 * The main app (main.tsx) is protected by CDN-level JWT validation.
 * Users who are not authenticated will be redirected here to login.
 */
import * as ReactDOM from 'react-dom/client';

import { setAuthSettings } from '@bedc/client/auth/utils';

import { PublicApp } from './app/PublicApp';
import { PublicProvider } from './app/PublicProvider';
import { environment } from './environments/environment';

// No service worker registration for public pages

// Set auth settings for OIDC. Only the login and logout routes use them.
setAuthSettings(
	environment.aws.cognito.region,
	environment.aws.cognito.userPoolId,
	environment.aws.cognito.userPoolWebClientId,
	environment.aws.cognito.identityPoolId,
	environment.aws.cognito.customDomain
);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
	<PublicProvider>
		<PublicApp />
	</PublicProvider>
);
